<template>
  <div class="mx-2">
    <NavigationBreadcrumb :items="breadcrumb_items"></NavigationBreadcrumb>
    <!-- Titulo -->
    <div>
      <div class="text-right">
        <GenericButtonDownload
          v-if="
            user &&
            ([
              'DIRECTIVOS ACADÉMICOS INSTITUCIONALES',
              'DIRECTIVOS ACADÉMICOS (CAMPUS)',
              'DIRECTIVOS FACULTAD O ESCUELA',
              'DIRECTORES DE CARRERA',
              'DIRECTORES DE CARRERA (CAMPUS)',
              'ADMINISTRATIVOS INSTRUCCIONALES',
            ].some((group) => user.group_names.includes(group)) ||
              user.is_superuser)
          "
          :tooltip_text="
            $t('matterProgram.matterProgramByEgressProfileView.evaluationsXlsx')
          "
          :click_button="DownloadEvaluationsEgressProfileXLS"
          :class="`mt-2 mr-3`"
          :icon_excel="true"
        ></GenericButtonDownload>
        <!-- <b-button
          size="sm"
          class="mr-2 noprint"
          @click="DownloadEvaluationsEgressProfileXLS"
        >
          <b-icon-download class="mr-1 icon-download"></b-icon-download>
          EVALUACIONES XLS
        </b-button> -->
      </div>
    </div>
    <!-- Tabla -->
    <div class="mt-2">
      <template>
        <div class="learning-experiences-container">
          <TableSkeleton
            v-if="loading"
            :columns="16"
            :rows="12"
            :table_props="{
              bordered: true,
              'no-border-collapse': true,
              small: true,
              responsive: true,
            }"
          />
          <b-table-simple
            v-else
            bordered
            no-border-collapse
            small
            responsive
            :sticky-header="stickyHeaderSize"
            class="txt-custom"
          >
            <b-thead>
              <b-tr>
                <b-th class="text-center primary-header" colspan="16">{{
                  $t(
                    "matterProgram.matterProgramByEgressProfileView.evaluations"
                  )
                }}</b-th>
              </b-tr>
              <b-tr>
                <b-th class="text-center align-middle secondary-header">{{
                  $t(
                    "matterProgram.matterProgramByEgressProfileView.colSubjectCode"
                  )
                }}</b-th>
                <b-th class="text-center align-middle secondary-header">{{
                  $t(
                    "matterProgram.matterProgramByEgressProfileView.colSubject"
                  )
                }}</b-th>
                <b-th class="text-center align-middle secondary-header">{{
                  $t(
                    "matterProgram.matterProgramByEgressProfileView.colPlanLevel"
                  )
                }}</b-th>
                <b-th class="text-center align-middle secondary-header">{{
                  $t(
                    "matterProgram.matterProgramByEgressProfileView.colEvaluationType"
                  )
                }}</b-th>
                <b-th class="text-center align-middle secondary-header">{{
                  $t(
                    "matterProgram.matterProgramByEgressProfileView.colLearningOutcome"
                  )
                }}</b-th>
                <b-th class="text-center align-middle secondary-header">{{
                  $t(
                    "matterProgram.matterProgramByEgressProfileView.colAchievementIndicators"
                  )
                }}</b-th>
                <b-th class="text-center align-middle secondary-header">{{
                  $t(
                    "matterProgram.matterProgramByEgressProfileView.colEvaluativeSituation"
                  )
                }}</b-th>
                <b-th
                  class="text-center align-middle secondary-header"
                  v-b-tooltip.v-secondary.noninteractive="
                    $t(
                      'matterProgram.matterProgramByEgressProfileView.colEvaluationDescriptionTooltip'
                    )
                  "
                  >{{
                    $t(
                      "matterProgram.matterProgramByEgressProfileView.colEvaluationDescription"
                    )
                  }}</b-th
                >
                <b-th class="text-center align-middle secondary-header">{{
                  $t(
                    "matterProgram.matterProgramByEgressProfileView.colEvaluativeAgent"
                  )
                }}</b-th>
                <b-th class="text-center align-middle secondary-header">{{
                  $t(
                    "matterProgram.matterProgramByEgressProfileView.colEvaluationWeighting"
                  )
                }}</b-th>
                <b-th class="text-center align-middle secondary-header">{{
                  $t(
                    "matterProgram.matterProgramByEgressProfileView.colSituationWeighting"
                  )
                }}</b-th>
                <b-th class="text-center align-middle secondary-header">{{
                  $t(
                    "matterProgram.matterProgramByEgressProfileView.colDirectedTeachingHours"
                  )
                }}</b-th>
                <b-th class="text-center align-middle secondary-header">{{
                  $t(
                    "matterProgram.matterProgramByEgressProfileView.colAutonomousWorkHours"
                  )
                }}</b-th>
                <b-th class="text-center align-middle secondary-header">{{
                  $t(
                    "matterProgram.matterProgramByEgressProfileView.colWorkType"
                  )
                }}</b-th>
                <b-th class="text-center align-middle secondary-header">{{
                  $t(
                    "matterProgram.matterProgramByEgressProfileView.colEnvironment"
                  )
                }}</b-th>
                <b-th class="text-center align-middle secondary-header">{{
                  $t(
                    "matterProgram.matterProgramByEgressProfileView.colExaminer"
                  )
                }}</b-th>
              </b-tr>
            </b-thead>
            <b-tbody>
              <template v-if="matter_evaluations_by_egress_profile.length > 0">
                <template
                  v-for="(
                    matter, index
                  ) in matter_evaluations_by_egress_profile"
                >
                  <template
                    v-for="(
                      matter_evaluation, index2
                    ) in matter.matter_evaluations"
                  >
                    <b-tr
                      v-for="(
                        evaluation_test, index3
                      ) in matter_evaluation.tests"
                      :key="
                        'matter' +
                        index +
                        'matter_evalaution ' +
                        matter_evaluation.id +
                        index2 +
                        'index_test' +
                        index3
                      "
                    >
                      <!-- Sigla Asignatura -->
                      <b-td
                        v-if="index2 == 0 && index3 == 0"
                        :rowspan="getRowEvaluation(matter.matter_evaluations)"
                        class="text-left align-middle"
                      >
                        <span
                          v-b-tooltip.v-secondary.noninteractive="
                            `${$getVisibleNames('manual.matter_code', false, 'Código')}`
                          "
                        >{{ getBaseMatterCode(matter.id) || matter.matter_code }}</span>
                        <template
                          v-if="
                            institution &&
                            institution.use_epm_code &&
                            matter.matter_code &&
                            getBaseMatterCode(matter.id) &&
                            matter.matter_code !== getBaseMatterCode(matter.id)
                          "
                        >
                          -
                          <span
                            v-b-tooltip.v-secondary.noninteractive="
                              `${$getVisibleNames('manual.ep_matter_code', false, 'Código')}`
                            "
                          >{{ matter.matter_code }}</span>
                        </template>
                      </b-td>
                      <!-- Asignatura -->
                      <b-td
                        v-if="index2 == 0 && index3 == 0"
                        :rowspan="getRowEvaluation(matter.matter_evaluations)"
                        class="text-left align-middle"
                      >
                        {{ matter.matter_name }}
                      </b-td>
                      <!-- Nivel del Plan -->
                      <b-td
                        v-if="index2 == 0 && index3 == 0"
                        :rowspan="getRowEvaluation(matter.matter_evaluations)"
                        class="text-center align-middle p-4"
                      >
                        {{ matter.matter_plan_level }}
                      </b-td>
                      <!-- Tipo de evaluación -->
                      <b-td
                        v-if="index3 == 0"
                        :rowspan="matter_evaluation.tests.length"
                        class="text-left"
                      >
                        {{ matter_evaluation.evaluation_type }}
                      </b-td>
                      <!-- Resultado de aprendizaje -->
                      <b-td
                        v-if="index3 == 0"
                        :rowspan="matter_evaluation.tests.length"
                      >
                        {{ matter_evaluation.learning_results }}
                      </b-td>
                      <!-- Indicadores de Logro -->
                      <b-td
                        v-if="index3 == 0"
                        :rowspan="matter_evaluation.tests.length"
                      >
                        {{ matter_evaluation.evaluation_criterias_micro }}
                      </b-td>
                      <!-- Situación evaluativa -->
                      <b-td class="text-left">
                        {{ evaluation_test.evaluation_situation }}
                      </b-td>
                      <!-- Descripción evaluación -->
                      <b-td
                        v-if="index3 == 0"
                        :rowspan="matter_evaluation.tests.length"
                      >
                        <RenderVHtml
                          class="description-evaluation"
                          :content="matter_evaluation.description"
                        ></RenderVHtml>
                      </b-td>
                      <!-- Agente evaluativo -->
                      <b-td class="text-left">
                        <div>
                          {{ evaluation_test.evaluative_agent }}
                        </div>
                      </b-td>
                      <!-- Ponderación evaluación -->
                      <b-td
                        v-if="index3 == 0"
                        :rowspan="matter_evaluation.tests.length"
                      >
                        {{ matter_evaluation.weighing }}%</b-td
                      >
                      <!-- Ponderación por Situacion Evaluativa -->
                      <b-td> {{ evaluation_test.weighing }}% </b-td>
                      <!-- Horas de Docencia Dirigida (pedagógicas) -->
                      <b-td
                        v-if="index3 == 0"
                        :rowspan="matter_evaluation.tests.length"
                        class="text-left"
                      >
                        <div
                          v-for="(
                            pedagogical_hour, index
                          ) in matter_evaluation.pedagogical_hours.filter(
                            (x) => x.hours > 0
                          )"
                          :key="index"
                        >
                          <p>
                            {{ pedagogical_hour.hours }} Hrs.
                            {{
                              pedagogical_hour.study_environment != null
                                ? pedagogical_hour.study_environment
                                : `Sin ${$getVisibleNames(
                                    "mesh.studyenvironment",
                                    false,
                                    "Ambiente de Aprendizaje"
                                  )}`
                            }}
                          </p>
                        </div>
                      </b-td>
                      <!-- Horas de Trabajo Autónomo Preparación y/o Ejecución
                  (cronológicas) -->
                      <b-td
                        v-if="index3 == 0"
                        :rowspan="matter_evaluation.tests.length"
                        class="text-left"
                      >
                        <div
                          v-for="(
                            chronological_hour, index
                          ) in matter_evaluation.chronological_hours.filter(
                            (x) => x.hours > 0
                          )"
                          :key="index"
                        >
                          <p>
                            {{ chronological_hour.hours }} Hrs.
                            {{
                              chronological_hour.study_environment != null
                                ? chronological_hour.study_environment
                                : `Sin ${$getVisibleNames(
                                    "mesh.studyenvironment",
                                    false,
                                    "Ambiente de Aprendizaje"
                                  )}`
                            }}
                          </p>
                        </div>
                      </b-td>
                      <!-- Tipo de trabajo -->
                      <b-td>
                        {{ evaluation_test.work_type }}
                      </b-td>
                      <!-- Ambiente -->
                      <b-td
                        v-if="index3 == 0"
                        :rowspan="matter_evaluation.tests.length"
                      >
                        {{ matter_evaluation.study_environments }}
                      </b-td>
                      <!-- Examinador/a -->
                      <b-td>
                        {{ evaluation_test.examiner }}
                      </b-td>
                    </b-tr>
                    <!-- Template para cuando no existen test -->
                    <template v-if="matter_evaluation.tests.length == 0">
                      <b-tr
                        :key="
                          'matter' +
                          index +
                          'matter_evalaution ' +
                          matter_evaluation.id +
                          index2
                        "
                      >
                        <!-- Sigla Asignatura -->
                        <b-td
                          v-if="index2 == 0"
                          :rowspan="matter.matter_evaluations.length"
                          class="text-left align-middle"
                        >
                          <span
                            v-b-tooltip.v-secondary.noninteractive="
                              `${$getVisibleNames('manual.matter_code', false, 'Código')}`
                            "
                          >{{ getBaseMatterCode(matter.id) || matter.matter_code }}</span>
                          <template
                            v-if="
                              institution &&
                              institution.use_epm_code &&
                              matter.matter_code &&
                              getBaseMatterCode(matter.id) &&
                              matter.matter_code !== getBaseMatterCode(matter.id)
                            "
                          >
                            -
                            <span
                              v-b-tooltip.v-secondary.noninteractive="
                                `${$getVisibleNames('manual.ep_matter_code', false, 'Código')}`
                              "
                            >{{ matter.matter_code }}</span>
                          </template>
                        </b-td>
                        <!-- Asignatura -->
                        <b-td
                          v-if="index2 == 0"
                          :rowspan="matter.matter_evaluations.length"
                          class="text-left align-middle"
                        >
                          {{ matter.matter_name }}
                        </b-td>
                        <!-- Nivel del Plan -->
                        <b-td
                          v-if="index2 == 0"
                          :rowspan="matter.matter_evaluations.length"
                          class="text-center align-middle"
                        >
                          {{ matter.matter_plan_level }}
                        </b-td>
                        <!-- Tipo de evaluación -->
                        <b-td class="text-left">
                          {{ matter_evaluation.evaluation_type }}
                        </b-td>
                        <!-- Resultado de aprendizaje -->
                        <b-td>
                          {{ matter_evaluation.learning_results }}
                        </b-td>
                        <!-- Indicadores de Logro -->
                        <b-td>
                          {{ matter_evaluation.evaluation_criterias_micro }}
                        </b-td>
                        <!-- Situación evaluativa -->
                        <b-td class="text-left"> </b-td>
                        <!-- Descripción evaluación -->
                        <b-td>
                          <RenderVHtml
                            class="description-evaluation"
                            :content="matter_evaluation.description"
                          ></RenderVHtml>
                        </b-td>
                        <!-- Agente evaluativo -->
                        <b-td class="text-left">
                          <div></div>
                        </b-td>
                        <!-- Ponderación evaluación -->
                        <b-td> {{ matter_evaluation.weighing }}%</b-td>
                        <!-- Ponderación por Situacion Evaluativa -->
                        <b-td> </b-td>
                        <!-- Horas de Docencia Dirigida (pedagógicas) -->
                        <b-td class="text-left">
                          <div
                            v-for="(
                              pedagogical_hour, index
                            ) in matter_evaluation.pedagogical_hours.filter(
                              (x) => x.hours > 0
                            )"
                            :key="index"
                          >
                            <p>
                              {{ pedagogical_hour.hours }} Hrs.
                              {{
                                pedagogical_hour.study_environment != null
                                  ? pedagogical_hour.study_environment
                                  : `Sin ${$getVisibleNames(
                                      "mesh.studyenvironment",
                                      false,
                                      "Ambiente de Aprendizaje"
                                    )}`
                              }}
                            </p>
                          </div>
                        </b-td>
                        <!-- Horas de Trabajo Autónomo Preparación y/o Ejecución
                  (cronológicas) -->
                        <b-td class="text-left">
                          <div
                            v-for="(
                              chronological_hour, index
                            ) in matter_evaluation.chronological_hours.filter(
                              (x) => x.hours > 0
                            )"
                            :key="index"
                          >
                            <p>
                              {{ chronological_hour.hours }} Hrs.
                              {{
                                chronological_hour.study_environment != null
                                  ? chronological_hour.study_environment
                                  : `Sin ${$getVisibleNames(
                                      "mesh.studyenvironment",
                                      false,
                                      "Ambiente de Aprendizaje"
                                    )}`
                              }}
                            </p>
                          </div>
                        </b-td>
                        <!-- Tipo de trabajo -->
                        <b-td> </b-td>
                        <!-- Ambiente -->
                        <b-td>
                          {{ matter_evaluation.study_environments }}
                        </b-td>
                        <!-- Examinador/a -->
                        <b-td> </b-td>
                      </b-tr>
                    </template>
                  </template>
                </template>
              </template>
              <!-- Template cuando no hay evaluaciones -->
              <template
                v-else-if="matter_evaluations_by_egress_profile.length == 0"
              >
                <b-tr>
                  <b-td colspan="16">
                    <strong>{{
                      $t(
                        "matterProgram.matterProgramByEgressProfileView.noDataToShow"
                      )
                    }}</strong>
                  </b-td>
                </b-tr>
              </template>
            </b-tbody>
          </b-table-simple>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { downloadFileFromResponse, showLoadingAlert } from "@/utils/utils";
export default {
  name: "MatterProgramByEgressProfileView",
  components: {
    RenderVHtml: () => import("@/components/reusable/RenderVHtml"),
    GenericButtonDownload: () =>
      import("@/components/reusable/Buttons/GenericButtonDownload"),
    TableSkeleton: () => import("@/components/reusable/TableSkeleton"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {},
  data() {
    return {
      matter_evaluations_by_egress_profile: [],
      egress_profile_id: Number(this.$route.params.egress_profile_id),
      stickyHeaderSize: "1000px",
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      institution: "getInstitution",
      matters_list: names.MATTERS,
    }),
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames("mesh.career", true, "Programas"),
          to: "/careers",
        },
        {
          text: this.$getVisibleNames(
            "mesh.egressprofile",
            false,
            "Perfil de Egreso"
          ),
          to: `/egress-profile/form/${this.egress_profile_id}`,
        },
        {
          text: this.$t(
            "matterProgram.matterProgramByEgressProfileView.breadcrumbEvaluations"
          ),
        },
      ];
    },
  },
  methods: {
    getBaseMatterCode(matter_id) {
      const matter = this.matters_list.find((x) => x.id == matter_id);
      return matter ? matter.code : "";
    },
    getRowEvaluation(evaluations) {
      let row = 0;
      evaluations.forEach((x) => {
        if (x.tests.length == 0) {
          row++;
        } else row += x.tests.length;
      });
      return row;
    },
    getMatterEvaluationsByEgressProfile() {
      this.loading = true;
      this.$restful
        .Get(
          `/teaching/matter_evaluations_by_egress_profile/?egress_profile=${this.egress_profile_id}`
        )
        .then((response) => {
          this.matter_evaluations_by_egress_profile = response;
          this.loading = false;
        });
    },
    DownloadEvaluationsEgressProfileXLS() {
      showLoadingAlert(
        this.$t(
          "matterProgram.matterProgramByEgressProfileView.generatingExcel"
        ),
        this.$t(
          "matterProgram.matterProgramByEgressProfileView.pleaseWaitWhileGenerating"
        )
      );
      this.$restful
        .Post(
          `/teaching/egress_profile_evaluations_excel_report/`,
          {
            egress_profile: this.egress_profile_id,
          },
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          this.$swal.close();
          downloadFileFromResponse(
            response,
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            () => {},
            () => {
              this.$swal.fire(
                this.$t("reusable.common.error"),
                this.$t(
                  "matterProgram.matterProgramByEgressProfileView.downloadError"
                ),
                "error"
              );
            }
          );
        })
        .catch(() => {
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t(
              "matterProgram.matterProgramByEgressProfileView.generationError"
            ),
            "error"
          );
        });
    },
    updateStickyHeaderSize() {
      const viewportHeight = window.innerHeight;
      const newStickyHeaderSize = viewportHeight * 1 + "px"; // Por ejemplo, 100% de la altura del viewport
      this.stickyHeaderSize = newStickyHeaderSize;
    },
  },
  mounted() {
    this.updateStickyHeaderSize();
    window.addEventListener("resize", this.updateStickyHeaderSize);
  },
  created() {
    this.$store.dispatch(names.FETCH_MATTERS, {
      egress_profile_id: this.egress_profile_id,
    });
    this.$store
      .dispatch(names.FETCH_EGRESS_PROFILE, this.egress_profile_id)
      .then((response) => {
        this.$store.commit(
          names.MUTATE_TITLE_OF_THE_PRINT,
          `Listado de ${this.$getVisibleNames(
            "evaluations2.evaluation",
            true,
            "Evaluaciones"
          )} del ${this.$getVisibleNames(
            "mesh.egressprofile",
            false,
            "Perfil de Egreso"
          )}- ${response.name}`
        );
      });
    this.getMatterEvaluationsByEgressProfile();
  },
  beforeDestroy() {
    this.$store.commit(names.RESET_TITLE_OF_THE_PRINT);
    window.removeEventListener("resize", this.updateStickyHeaderSize);
  },
};
</script>

<style scoped src="@/utils/rich_text_editor.css">
</style>

<style scoped>
.primary-header {
  background: black !important;
  color: white !important;
  font-weight: bold !important;
  font-size: 26px;
}
.secondary-header {
  background: #d0cece !important;
}
.txt-custom {
  font-size: 9pt;
}
.description-evaluation {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
@media print {
  .learning-experiences-container {
    zoom: 52%;
    display: table;
    table-layout: inherit;
  }
  .description-evaluation {
    max-height: none;
    height: auto;
    overflow-y: hidden;
  }
}
</style>